import { XYChart } from '@amcharts/amcharts5/xy';
import React from 'react';

import { events } from 'features/Events/components/EventsChart/utils/events';
import { setSeries } from 'features/Events/components/EventsChart/utils/setSeries';
import { EventData } from 'features/Events/types/eventData';
import { am5Root, am5XYChart, categoryAxis, dateAxis } from 'utils/charts/charts';
import { setAxisRenderer } from 'utils/charts/setAxisRenderer';
import { setCursor } from 'utils/charts/setCursor';
import {
  cursorSettings,
  getXYChartSettings,
  xAxisRendererSettings,
  xAxisEventsSettings,
  yAxisRendererSettings,
  yAxisSettings,
} from 'utils/charts/settings';

export const initialiseChart = (
  chartId: string,
  minDateTimeRange: string,
  maxDateTimeRange: string,
  chartData: EventData[],
  lineColor: string,
  setShowModal: (show: boolean) => void,
  setModalContent: (popup: React.ReactElement) => void
) => {
  const root = am5Root(chartId);
  const chart: XYChart = root.container.children.push(am5XYChart(root, getXYChartSettings()));

  setCursor(root, chart, cursorSettings);

  const yAxis = chart.yAxes.push(categoryAxis(root, yAxisSettings(root)));
  yAxis.data.setAll(events);

  const xAxis = chart.xAxes.push(
    dateAxis(root, xAxisEventsSettings(root, minDateTimeRange, maxDateTimeRange))
  );

  setAxisRenderer(yAxis, yAxisRendererSettings);
  setAxisRenderer(xAxis, xAxisRendererSettings);

  setSeries(root, chart, yAxis, xAxis, chartData, lineColor, setShowModal, setModalContent);
  chart.appear(1000, 100);
  return root;
};
